/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Force_UnlockInputs */

const cs_workflow_force_unlock = /** @type {(inputs: Workflow_Force_UnlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vynutit odemčení`)
};

const en_workflow_force_unlock = /** @type {(inputs: Workflow_Force_UnlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Force unlock`)
};

/**
* | output |
* | --- |
* | "Force unlock" |
*
* @param {Workflow_Force_UnlockInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_force_unlock = /** @type {((inputs?: Workflow_Force_UnlockInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Force_UnlockInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_force_unlock(inputs)
	return cs_workflow_force_unlock(inputs)
});